import { render } from "./onboarding.vue?vue&type=template&id=192533e0&ts=true"
import script from "./onboarding.vue?vue&type=script&lang=ts"
export * from "./onboarding.vue?vue&type=script&lang=ts"

import "./onboarding.vue?vue&type=style&index=0&id=192533e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__